import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=b18c1efa&scoped=true&lang=pug"
import script from "./TitleSection.vue?vue&type=script&lang=js"
export * from "./TitleSection.vue?vue&type=script&lang=js"
import style0 from "./TitleSection.vue?vue&type=style&index=0&id=b18c1efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18c1efa",
  null
  
)

export default component.exports